/* ==========================================================================
   Snack Box page
   --------------------------------------------------------------------------
   Vanilla JS, no dependencies, scoped to a [data-sbp] root.

   Flow: pick a box size -> the sticky bar arms -> "Add to cart" opens the
   guided quiz (craving -> allergies -> email -> summary) -> Checkout on the
   summary is the only step that actually posts to /cart/add.

   Opening the quiz needs no product, so the whole flow is demoable while the
   box product is still archived. Only Checkout depends on it.

   With JS off: the sticky bar is hidden by CSS and each box card is a real
   cart form, so the boxes remain purchasable and nothing dead is shown.
   ========================================================================== */

(function () {
  'use strict';

  var STORE = 'rb_sbp_v1:';
  var STEPS = ['craving', 'allergies', 'email'];
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function init(root) {
    var cfgEl = root.querySelector('[data-sbp-config]');
    if (!cfgEl) return;

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var key = STORE + (root.dataset.sbpId || 'default');
    var L = cfg.labels;

    var el = {
      browse: root.querySelector('[data-sbp-browse]'),
      quiz: root.querySelector('[data-sbp-quiz]'),
      panels: root.querySelectorAll('[data-sbp-panel]'),
      dots: root.querySelectorAll('[data-sbp-step-dot]'),
      planBtns: root.querySelectorAll('[data-sbp-plan]'),
      prices: root.querySelectorAll('[data-sbp-price]'),
      selects: root.querySelectorAll('[data-sbp-select]'),
      boxes: root.querySelectorAll('[data-sbp-box]'),
      pickerBar: root.querySelector('[data-sbp-bar="picker"]'),
      checkoutBar: root.querySelector('[data-sbp-bar="checkout"]'),
      heroCta: root.querySelector('[data-sbp-hero-cta]'),
      picker: root.querySelector('[data-sbp-picker]'),
      email: root.querySelector('[data-sbp-email]'),
      emailErr: root.querySelector('[data-sbp-email-err]'),
      sumName: root.querySelector('[data-sbp-sum-name]'),
      sumSlots: root.querySelector('[data-sbp-sum-slots]'),
      sumAmount: root.querySelector('[data-sbp-sum-amount]'),
      sumUnit: root.querySelector('[data-sbp-sum-unit]'),
      sumImg: root.querySelector('[data-sbp-sum-img]'),
      sumPh: root.querySelector('[data-sbp-sum-ph]'),
      sumCheckout: root.querySelector('[data-sbp-sum-checkout]'),
      checkoutErr: root.querySelector('[data-sbp-checkout-err]'),
      stepGos: root.querySelectorAll('[data-sbp-step-go]'),
      skips: root.querySelectorAll('[data-sbp-skip]'),
      exit: root.querySelector('[data-sbp-exit]'),
      crumbThumb: root.querySelector('[data-sbp-crumb-thumb]'),
      crumbBox: root.querySelector('[data-sbp-crumb-box]'),
      faqs: root.querySelectorAll('[data-sbp-faq-q]')
    };

    var state = {
      view: 'browse',     // browse | quiz
      step: 'craving',
      /* A stored choice or a URL parameter still wins — this is only what a
         first-time visitor sees. */
      plan: cfg.defaultPlan === 'onetime' ? 'onetime' : 'subscribe',
      /* Pre-selected box, by position, from the "Pre-selected box" setting.
         Blank means nothing is chosen and the shopper has to pick. */
      box: ((cfg.boxes || [])[(parseInt(cfg.defaultBox, 10) || 0) - 1] || {}).id || null,
      craving: [],
      allergies: [],
      email: ''
    };

    /* --- helpers --------------------------------------------------------- */

    function boxById(id) {
      for (var i = 0; i < cfg.boxes.length; i++) if (cfg.boxes[i].id === id) return cfg.boxes[i];
      return null;
    }
    function boxBySize(sz) {
      for (var i = 0; i < cfg.boxes.length; i++) if (cfg.boxes[i].size === sz) return cfg.boxes[i];
      return null;
    }
    function current() { return state.box ? boxById(state.box) : null; }

    function priceOf(b) {
      if (!b) return L.priceUnset;
      if (state.plan !== 'subscribe') return b.price || L.priceUnset;
      return b.priceSubscribe || discounted(b.price) || b.price || L.priceUnset;
    }

    /* Tiers carry no subscribe price yet, so one is derived from the one-time
       figure and the configured discount — otherwise the toggle claims a saving
       and then shows an unchanged number. The charge still comes from the
       selling plan, so the setting must be kept equal to it. */
    function discounted(price) {
      if (!price || !cfg.subscribeDiscount) return '';
      var m = String(price).match(/^([^0-9]*)([0-9.,]+)([^0-9]*)$/);
      if (!m) return '';
      var n = parseFloat(m[2].replace(/,/g, ''));
      if (!isFinite(n)) return '';
      var v = n * (1 - cfg.subscribeDiscount / 100);
      return m[1] + (Math.abs(v % 1) < 0.005 ? v.toFixed(0) : v.toFixed(2)) + m[3];
    }
    function unitOf() { return state.plan === 'subscribe' ? L.unitSubscribe : L.unitOnetime; }

    /* --- persistence ------------------------------------------------------ */

    function save() {
      try {
        localStorage.setItem(key, JSON.stringify({
          plan: state.plan, box: state.box, craving: state.craving,
          allergies: state.allergies, email: state.email
        }));
      } catch (e) { /* private mode — still works for this visit */ }
    }

    function restoreStore() {
      var raw;
      try { raw = localStorage.getItem(key); } catch (e) { return; }
      if (!raw) return;
      try {
        var d = JSON.parse(raw);
        /* Deliberately NOT restoring the plan: the merchant's default should
           win on every fresh visit. The box and the quiz answers still persist. */
        /* Deliberately NOT restoring the box, for the same reason as the
           plan: the pre-selection should win on a fresh visit. */
        if (Array.isArray(d.craving)) state.craving = d.craving.slice(0, cfg.maxCraving);
        if (Array.isArray(d.allergies)) state.allergies = d.allergies;
        if (typeof d.email === 'string') state.email = d.email;
      } catch (e) { /* ignore corrupt payloads */ }
    }

    /* --- deep link -------------------------------------------------------- */

    function restoreUrl() {
      var p = new URLSearchParams(location.search);
      var size = p.get('size');
      if (size) { var b = boxBySize(size); if (b) { state.box = b.id; sizeTouched = true; } }
      var plan = p.get('plan');
      if (plan === 'sub' || plan === 'subscribe') { state.plan = 'subscribe'; planTouched = true; }
      else if (plan === 'onetime' || plan === 'one') { state.plan = 'onetime'; planTouched = true; }
      var step = p.get('step');
      if (step === 'summary' || STEPS.indexOf(step) > -1) { state.view = 'quiz'; state.step = step; }
    }

    function syncUrl() {
      if (!history.replaceState) return;
      var p = new URLSearchParams(location.search);
      if (state.view === 'quiz') p.set('step', state.step); else p.delete('step');
      var b = current();
      if (b && sizeTouched) p.set('size', b.size); else p.delete('size');
      /* Only pin the plan once the shopper has chosen it. Writing it on every
         visit meant the URL sitting in someone's history carried an old choice
         and silently overrode the default the next time they opened it. */
      if (planTouched) p.set('plan', state.plan === 'subscribe' ? 'sub' : 'onetime');
      else p.delete('plan');
      var qs = p.toString();
      history.replaceState(null, '', qs ? '?' + qs : location.pathname);
    }

    /* --- rendering -------------------------------------------------------- */

    function renderPlan() {
      Array.prototype.forEach.call(el.planBtns, function (b) {
        b.setAttribute('aria-pressed', b.dataset.sbpPlan === state.plan ? 'true' : 'false');
      });
      Array.prototype.forEach.call(el.prices, function (p) {
        var one = p.dataset.onetime || '', sub = p.dataset.subscribe || '';
        var amt = p.querySelector('[data-sbp-amount]'), unit = p.querySelector('[data-sbp-unit]');
        if (!amt || !unit) return;
        var shown = state.plan === 'subscribe' ? (sub || discounted(one) || one) : one;
        amt.textContent = shown || L.priceUnset;
        amt.classList.toggle('sbp-box__amount--unset', !shown);
        unit.textContent = unitOf();
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-sbp-box-plan]'), function (i) {
        i.value = state.plan === 'subscribe' ? (cfg.sellingPlanId || '') : '';
        i.disabled = state.plan !== 'subscribe' || !cfg.sellingPlanId;
      });
    }

    function renderBoxes() {
      /* Once anything is chosen, the merchant's highlight stands down so only
         the shopper's own selection carries the outline. */
      root.classList.toggle('sbp--picked', !!state.box);
      Array.prototype.forEach.call(el.boxes, function (b) {
        b.classList.toggle('is-selected', b.dataset.sbpBox === state.box);
      });
      Array.prototype.forEach.call(el.selects, function (btn) {
        var on = btn.dataset.sbpSelect === state.box;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.classList.toggle('sbp-btn--chosen', on);
        btn.classList.toggle('sbp-btn--outline', !on);
        btn.textContent = on ? L.selected : L.select;
      });
    }

    function setBar(bar, title, sub, amount, disabled, reason, cta) {
      if (!bar) return;
      bar.querySelector('[data-sbp-bar-title]').textContent = title;
      bar.querySelector('[data-sbp-bar-sub]').textContent = sub;
      bar.querySelector('[data-sbp-bar-amount]').textContent = amount;
      var btn = bar.querySelector('[data-sbp-bar-cta]');
      btn.disabled = !!disabled;
      btn.textContent = cta;
      if (reason) btn.setAttribute('title', reason); else btn.removeAttribute('title');
    }

    function renderBars() {
      var b = current();
      var browsing = state.view === 'browse';

      if (el.pickerBar) el.pickerBar.hidden = !browsing;
      if (el.checkoutBar) el.checkoutBar.hidden = !(state.view === 'quiz' && state.step === 'summary');

      if (browsing) {
        if (b) {
          setBar(el.pickerBar, L.selectedTitle.replace('{name}', b.name),
                 b.slots + ' ' + L.slotsWord + ' · ' + planWord(),
                 priceOf(b), false, '', L.addToCart);
        } else {
          setBar(el.pickerBar, L.emptyTitle, L.emptySub, L.priceUnset, true, L.reasonPickSize, L.addToCart);
        }
        return;
      }

      if (b) {
        setBar(el.checkoutBar, b.name, b.slots + ' ' + L.slotsWord, priceOf(b),
               !cfg.canBuy || !b.variantId, cfg.canBuy ? '' : L.reasonNoProduct, L.checkout);
      }
    }

    function planWord() { return state.plan === 'subscribe' ? L.planSubscribe : L.planOnetime; }

    function renderQuizChrome() {
      if (el.browse) el.browse.hidden = state.view === 'quiz';
      if (el.quiz) el.quiz.hidden = state.view !== 'quiz';

      var idx = STEPS.indexOf(state.step);
      var done = state.step === 'summary';

      Array.prototype.forEach.call(el.dots, function (d) {
        var key = d.dataset.sbpStepDot;
        var i = STEPS.indexOf(key);
        d.classList.toggle('is-active', !done && i === idx);
        d.classList.toggle('is-done', done || (i > -1 && i < idx));
        if (!done && i === idx) d.setAttribute('aria-current', 'step');
        else d.removeAttribute('aria-current');
        /* Never disable the step you are currently on — skipping ahead can
           land you on a step whose prerequisites were bypassed. */
        if (d.tagName === 'BUTTON') d.disabled = !stepReachable(key) && key !== state.step;
      });

      Array.prototype.forEach.call(el.panels, function (p) {
        p.hidden = p.dataset.sbpPanel !== state.step;
      });

      /* Show the chosen box on the way-back control. Unhide before assigning
         src — a hidden image never queues its fetch. */
      var cb = current();
      if (el.crumbBox) el.crumbBox.textContent = cb ? cb.name : '';
      var thumbSrc = cb ? (cb.thumb || cb.image || cfg.summaryImage) : '';
      if (el.crumbThumb) {
        if (thumbSrc) {
          el.crumbThumb.hidden = false;
          if (el.crumbThumb.getAttribute('src') !== thumbSrc) el.crumbThumb.src = thumbSrc;
        } else {
          el.crumbThumb.hidden = true;
        }
      }
      if (el.exit && cb) {
        el.exit.setAttribute('aria-label', L.changeAria.replace('{box}', cb.name + ', ' + cb.slots + ' ' + L.slotsWord));
      }

      var target = cfg.skipTarget || 'email';
      Array.prototype.forEach.call(el.skips, function (b) {
        b.hidden = state.step === target;
      });
    }

    /* Going back is always allowed. Going forward is only allowed once every
       question before the target has been answered, so the stepper can never
       skip past a question the Continue button would have blocked. */
    function stepSatisfied(key) {
      if (key === 'craving') return state.craving.length > 0;
      if (key === 'email') return EMAIL_RE.test(state.email);
      return true;
    }

    function stepReachable(key) {
      var target = STEPS.indexOf(key);
      if (state.step === 'summary') return true;
      var cur = STEPS.indexOf(state.step);
      if (target <= cur) return true;
      for (var j = 0; j < target; j++) if (!stepSatisfied(STEPS[j])) return false;
      return true;
    }

    function renderAnswers() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-sbp-answer]'), function (i) {
        var g = i.dataset.sbpAnswer;
        var list = g === 'craving' ? state.craving : state.allergies;
        i.checked = list.indexOf(i.value) > -1;
      });
      /* Cap the craving picks: once the limit is reached, the unchosen rows
         disable outright rather than silently swallowing the click. */
      var full = state.craving.length >= cfg.maxCraving;
      Array.prototype.forEach.call(root.querySelectorAll('[data-sbp-answer="craving"]'), function (i) {
        i.disabled = full && !i.checked;
      });
      var nextC = root.querySelector('[data-sbp-next="craving"]');
      if (nextC) nextC.disabled = state.craving.length === 0;
    }

    function renderEmail() {
      if (!el.email) return;
      el.email.value = state.email;
      var ok = EMAIL_RE.test(state.email);
      var next = root.querySelector('[data-sbp-next="email"]');
      if (next) {
        next.disabled = !ok;
        if (!ok) next.setAttribute('title', L.reasonEmail); else next.removeAttribute('title');
      }
    }

    function renderSummary() {
      var b = current();
      if (!b) return;
      if (el.sumName) el.sumName.textContent = L.nameSuffix ? b.name + ' ' + L.nameSuffix : b.name;
      if (el.sumSlots) el.sumSlots.textContent = b.slots + ' ' + L.slotsWord;
      if (el.sumAmount) el.sumAmount.textContent = priceOf(b);
      if (el.sumUnit) el.sumUnit.textContent = unitOf();

      /* Show the well's placeholder until this size actually has an image, so
         an unset one is obviously "not uploaded" rather than a blank gap. */
      /* A section-level Summary image wins when set, so one hero shot can serve
         every size; otherwise each size falls back to its own box image. */
      var sumSrc = cfg.summaryImage || b.image;
      if (el.sumImg) {
        if (sumSrc) {
          /* Unhide BEFORE assigning src. Assigning it while the element is
             still hidden means the loader never queues the fetch, and the well
             stays blank even though the src attribute looks correct. */
          el.sumImg.hidden = false;
          if (el.sumPh) el.sumPh.hidden = true;
          if (el.sumImg.getAttribute('src') !== sumSrc) el.sumImg.src = sumSrc;
          el.sumImg.alt = b.name;
        } else {
          el.sumImg.hidden = true;
          if (el.sumPh) el.sumPh.hidden = false;
        }
      }
      if (el.sumCheckout) {
        var blocked = !cfg.canBuy || !b.variantId;
        el.sumCheckout.disabled = blocked;
        if (blocked) el.sumCheckout.setAttribute('title', L.reasonNoProduct);
        else el.sumCheckout.removeAttribute('title');
        /* No standing "not connected to a product" line under the button — the
           disabled state carries it, and the reason stays on the tooltip. The
           message area is still used for real checkout failures. */
        setCheckoutMessage('');
      }
    }

    function renderAll() {
      renderPlan(); renderBoxes(); renderQuizChrome();
      renderAnswers(); renderEmail(); renderSummary(); renderBars();
      syncBarHeight();
    }

    /* Clearance for the fixed bar, measured rather than guessed — its height
       changes with viewport width (it stacks on phones) and with content.

       The padding goes on <body>, not on this section: the bar is fixed over
       the whole page including the theme footer, which renders after the
       section, so an in-section spacer left the footer's copyright line and
       payment icons sitting underneath the bar. */
    function syncBarHeight() {
      var bar = state.view === 'browse' ? el.pickerBar : el.checkoutBar;
      if (!bar || bar.hidden) {
        document.body.style.paddingBottom = '';
        setChatLift(0);
        return;
      }
      var h = Math.round(bar.getBoundingClientRect().height);
      if (h > 0) {
        root.style.setProperty('--sbp-bar-h', h + 'px');
        document.body.style.paddingBottom = h + 'px';
        setChatLift(h);
      }
    }

    /* Lift the Shopify Inbox bubble clear of the sticky bar, and let it drop
       back when no bar is showing (quiz steps 1-3). Publishes the measured
       height rather than a constant, because the bar restacks on phones.
       Mirrors what sections/rb-pdp.liquid does for the product page. */
    function setChatLift(barHeight) {
      var b = document.body;
      if (barHeight <= 0) {
        b.style.removeProperty('--sbp-chat-offset');
        b.classList.remove('sbp-bar-open');
        return;
      }
      b.classList.add('sbp-bar-open');
      chatTries = 0;
      fitChat();
    }

    /* This measures rather than calculates. An earlier version derived the
       offset from the bar height using a constant read off a desktop browser,
       and it did not hold on a real phone: a device with a home indicator adds
       safe-area padding to the bar, so the bar is taller there than anything
       measurable here. Instead: set an offset, look at where the bubble
       actually landed, correct, repeat. Device independent, and it re-settles
       by itself if the widget or the bar changes size. */
    var CHAT_GAP = 16;
    var chatTries = 0;
    var planTouched = false;   // has the shopper chosen a plan this visit?
    var sizeTouched = false;   // has the shopper chosen a box this visit?

    function chatBubble() {
      var host = document.querySelector('shopify-chat, inbox-online-store-chat, #shopify-chat, #ShopifyChat');
      if (!host || !host.shadowRoot) return null;   // closed shadow root: cannot measure
      return host.shadowRoot.querySelector('.activator-nudge, button.activator, [class*="activator"]');
    }

    function fitChat() {
      var bar = state.view === 'browse' ? el.pickerBar : el.checkoutBar;
      if (!bar || bar.hidden) return;

      var bubble = chatBubble();
      if (!bubble) {
        /* Widget not mounted yet, or its shadow root is closed. Push it roughly
           clear and retry for a few seconds in case it is still loading. */
        var h = Math.round(bar.getBoundingClientRect().height);
        document.body.style.setProperty('--sbp-chat-offset', Math.max(20, h - 52) + 'px');
        if (chatTries++ < 12) setTimeout(fitChat, 500);
        return;
      }

      var gap = bar.getBoundingClientRect().top - bubble.getBoundingClientRect().bottom;
      if (Math.abs(gap - CHAT_GAP) <= 2) return;

      var current = parseFloat(getComputedStyle(document.body).getPropertyValue('--sbp-chat-offset')) || 20;
      document.body.style.setProperty('--sbp-chat-offset', Math.max(20, Math.round(current + (CHAT_GAP - gap))) + 'px');
      if (chatTries++ < 8) requestAnimationFrame(fitChat);
    }

    function scrollTo(node) {
      if (!node) return;
      var reduce = matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      node.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    /* --- interactions ----------------------------------------------------- */

    if (el.exit) {
      el.exit.addEventListener('click', function () {
        state.view = 'browse';
        renderAll(); save(); syncUrl();
        scrollTo(el.picker);
      });
    }

    Array.prototype.forEach.call(el.skips, function (btn) {
      btn.addEventListener('click', function () {
        state.view = 'quiz';
        state.step = cfg.skipTarget || 'email';
        renderAll(); save(); syncUrl();
        window.scrollTo({ top: 0, behavior: 'auto' });
      });
    });

    Array.prototype.forEach.call(el.stepGos, function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.sbpStepGo;
        if (!stepReachable(key)) return;
        state.view = 'quiz';
        state.step = key;
        renderAll(); save(); syncUrl();
        window.scrollTo({ top: 0, behavior: 'auto' });
      });
    });

    if (el.heroCta) {
      el.heroCta.addEventListener('click', function (e) {
        e.preventDefault();
        scrollTo(el.picker);
        /* Nudge the bar into its "pick a size" state so the CTA visibly leads
           somewhere even before a card is touched. */
        renderBars();
      });
    }

    Array.prototype.forEach.call(el.planBtns, function (b) {
      b.addEventListener('click', function () {
        state.plan = b.dataset.sbpPlan;
        planTouched = true;
        renderPlan(); renderBars(); renderSummary(); save(); syncUrl();
      });
    });

    Array.prototype.forEach.call(el.selects, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();               // no JS -> this stays a real submit
        var id = btn.dataset.sbpSelect;
        state.box = state.box === id ? null : id;
        sizeTouched = true;
        renderBoxes(); renderBars(); renderSummary(); save(); syncUrl();
      });
    });

    if (el.pickerBar) {
      el.pickerBar.querySelector('[data-sbp-bar-cta]').addEventListener('click', function () {
        if (!state.box) return;
        openQuiz('craving');
      });
    }

    function openQuiz(step) {
      state.view = 'quiz';
      state.step = step;
      renderAll(); save(); syncUrl();
      window.scrollTo({ top: 0, behavior: 'auto' });
    }

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-sbp-answer]');
      if (!input) return;
      var g = input.dataset.sbpAnswer;
      var list = g === 'craving' ? state.craving : state.allergies;
      var at = list.indexOf(input.value);
      if (input.checked && at === -1) list.push(input.value);
      else if (!input.checked && at > -1) list.splice(at, 1);
      renderAnswers(); renderQuizChrome(); save(); syncUrl();
    });

    if (el.email) {
      el.email.addEventListener('input', function () {
        state.email = el.email.value.trim();
        el.email.classList.remove('is-invalid');
        if (el.emailErr) el.emailErr.textContent = '';
        renderEmail(); renderQuizChrome(); save();
      });
      el.email.addEventListener('blur', function () {
        if (state.email && !EMAIL_RE.test(state.email)) {
          el.email.classList.add('is-invalid');
          if (el.emailErr) el.emailErr.textContent = L.reasonEmail;
        }
      });
    }

    root.addEventListener('click', function (e) {
      var next = e.target.closest('[data-sbp-next]');
      var back = e.target.closest('[data-sbp-back]');
      if (!next && !back) return;

      if (next) {
        if (next.disabled) return;
        var from = next.dataset.sbpNext;
        var i = STEPS.indexOf(from);
        state.step = i === STEPS.length - 1 ? 'summary' : STEPS[i + 1];
      } else {
        var f = back.dataset.sbpBack;
        var j = STEPS.indexOf(f);
        if (f === 'summary') state.step = STEPS[STEPS.length - 1];
        else if (j <= 0) { state.view = 'browse'; state.step = 'craving'; }
        else state.step = STEPS[j - 1];
      }
      renderAll(); save(); syncUrl();
      window.scrollTo({ top: 0, behavior: 'auto' });
    });

    /* FAQ accordions */
    Array.prototype.forEach.call(el.faqs, function (q) {
      q.addEventListener('click', function () {
        var open = q.getAttribute('aria-expanded') === 'true';
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
        var panel = document.getElementById(q.getAttribute('aria-controls'));
        if (panel) panel.hidden = open;
      });
    });

    /* --- checkout --------------------------------------------------------- */

    /* Checkout adds the box to the cart via /cart/add.js and then sends the
       shopper to /checkout. Doing it with fetch rather than a form post means a
       failure can be reported in place instead of dumping them on Shopify's
       error page.

       The whole path is live now; it only needs the box product to exist. Until
       a tier resolves to a variant the button stays disabled and says why, in
       text next to it rather than only in a tooltip. */
    function setCheckoutMessage(text, hard) {
      if (!el.checkoutErr) return;
      el.checkoutErr.textContent = text || '';
      el.checkoutErr.classList.toggle('sbp-sum__err--hard', !!hard);
    }

    function checkoutBusy(on) {
      if (el.sumCheckout) {
        el.sumCheckout.disabled = on;
        el.sumCheckout.textContent = on ? L.checkoutBusy : L.checkout;
      }
      if (el.checkoutBar) {
        var b = el.checkoutBar.querySelector('[data-sbp-bar-cta]');
        if (b) { b.disabled = on; b.textContent = on ? L.checkoutBusy : L.checkout; }
      }
    }

    function propertiesFor(b) {
      var props = {};
      props['_box_prefs'] = JSON.stringify({
        craving: state.craving, allergies: state.allergies,
        email: state.email, plan: state.plan, size: b.size
      });
      if (state.craving.length) props[L.propCraving] = state.craving.join(', ');
      props[L.propAllergies] = state.allergies.length ? state.allergies.join(', ') : L.allergiesNone;
      props[L.propBox] = b.name + ' \u00b7 ' + b.slots + ' ' + L.slotsWord;
      return props;
    }

    function checkout() {
      var b = current();
      if (!b) return;
      if (!cfg.canBuy || !b.variantId) { setCheckoutMessage(L.reasonNoProduct, true); return; }

      setCheckoutMessage('');
      checkoutBusy(true);

      var item = { id: b.variantId, quantity: 1, properties: propertiesFor(b) };
      if (state.plan === 'subscribe' && cfg.sellingPlanId) item.selling_plan = cfg.sellingPlanId;

      fetch(cfg.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (res) {
          if (res.ok) return res.json();
          return res.json().then(
            function (err) { throw new Error(err.description || err.message || String(res.status)); },
            function () { throw new Error(String(res.status)); }
          );
        })
        .then(function () { window.location.href = cfg.checkoutUrl; })
        .catch(function (err) {
          checkoutBusy(false);
          setCheckoutMessage(L.reasonCheckoutFailed + (err && err.message ? ' (' + err.message + ')' : ''), true);
        });
    }

    if (el.sumCheckout) el.sumCheckout.addEventListener('click', checkout);
    if (el.checkoutBar) {
      el.checkoutBar.querySelector('[data-sbp-bar-cta]').addEventListener('click', checkout);
    }

    /* --- boot ------------------------------------------------------------- */

    root.classList.add('sbp--js');

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncBarHeight, 150);
    });

    restoreStore();
    restoreUrl();                        // a URL wins over stored state
    if (state.view === 'quiz' && !state.box) { state.view = 'browse'; state.step = 'craving'; }
    renderAll();
    syncUrl();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-sbp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
